<template>
  <!-- Lista de valores: empresa -->
  <div class="modal fade" id="ModalEmpresaLOV" tabindex="-1" aria-labelledby="ModalLabelLOV" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header bg-primary">
          <h5 class="modal-title" id="ModalLabelLOV">
            <i class="fa fa-user-plus"></i> {{ tituloLOV }}
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          </button>
        </div>
        <div class="mb-3">
          <table class="tablaBusqueda">
            <tr>
              <td><label for="nombre" class="form-label">Nombre</label></td>
              <td><input type="text" class="form-control" id="nombreBusquedaLOV" name="nombreBusquedaLOV"
                  v-model="nombreBusquedaLOV" style="width: 500px; text-transform:uppercase;" required></td>
              <td>
                <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaLOV(1)"
                  title="Buscar registros">
                  Buscar
                </button>
              </td>
            </tr>
          </table>
        </div>
        <table class="table table-striped" id="sampleTableLOV">
          <thead>
            <tr>
              <th scope="col">nombre</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="empresa in datosPaginadosLOV" :key="empresa.idempresa">
                  <td><a href="#" v-on:click="seleccionarRegistro(empresa.idEmpresa, empresa.nombre)"
                      data-bs-target="#ventanaModal" data-bs-toggle="modal">{{ empresa.nombre }}</a></td>
            </tr>
          </tbody>
        </table>
        <nav aria-label="Page navigation example">
          <div class="row" style="text-align: center;">
            <div class="col"></div>
            <div class="col">
              <ul class="pagination">
                <li class="page-item" v-on:click="getPreviousPageLOV()"><a class="page-link" href="#">Anterior</a></li>
                <li class="page-item"><a class="page-link" href="#">{{ paginaActualLOV }}</a></li>
                <li class="page-item" v-on:click="getNextPageLOV()"><a class="page-link" href="#">Siguiente</a></li>
              </ul>
            </div>
            <div class="col"></div>
          </div>
        </nav>
      </div>
    </div>
  </div>
<!-- Lista de valores: Empresa -->
</template>
<script>
import api from "@/services/api";
export default {
  data() {
    return {
      // Lista de valores: Empresa
      nombreBusquedaLOV: '',
      tituloLOV: 'Lista de Empresa',
      EmpresaLOV: [],
      elementosPorPaginaLOV: 10,
      datosPaginadosLOV: [],
      paginaActualLOV: 1
      // Lista de valores: Empresa
    }
  },
  methods: {
    // Lista de valores: Empresa
    totalPaginasLOV() {
      return Math.ceil(this.EmpresaLOV.length / this.elementosPorPaginaLOV)
    },
    getDataPaginaLOV(noPagina) {
      if (this.nombreBusquedaLOV != null && this.nombreBusquedaLOV !== ""){
        api.get('/vwempresas/nombre/'+this.nombreBusquedaLOV).then(response=>{
          this.EmpresaLOV = response.data.reverse();
          this.paginaActualLOV = noPagina;
          this.datosPaginadosLOV = [];
          let ini = (noPagina * this.elementosPorPaginaLOV) - this.elementosPorPaginaLOV;
          let fin = (noPagina * this.elementosPorPaginaLOV);
          this.datosPaginadosLOV = this.EmpresaLOV.slice(ini, fin);
          this.datosPaginadosLOV = this.EmpresaLOV.slice(ini, fin);
        });
      }
      else{
        alert("ERROR: Ingrese un valor de consulta Empresa");
      }
    },
    getPreviousPageLOV() {
      if (this.paginaActualLOV > 1) {
        this.paginaActualLOV--;
      }
      this.getDataPaginaLOV(this.paginaActualLOV);
    },
    getNextPageLOV() {
      if (this.paginaActualLOV < this.totalPaginasLOV()) {
        this.paginaActualLOV++;
      }
      this.getDataPaginaLOV(this.paginaActualLOV);
    },
    seleccionarRegistro(p_idEmpresa, p_nombre) {
      this.$emit("DatosEmpresa", { idEmpresa: p_idEmpresa, nombre: p_nombre });
    }
  }
}
</script>
